import { Navigate } from 'react-router-dom';
import type { Permissions } from '@/shared/api';
import { useAuth } from '../model/AuthContext';

export function RequirePermission({
  permission,
  children,
  fallback = <Navigate to="/playground" replace />,
}: {
  permission: keyof Permissions;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  const { hasPermission } = useAuth();
  if (!hasPermission(permission)) {
    return fallback;
  }
  return children;
}
